import { PlanType } from '@showbie-socrative/socrative-utils';

import { setFeaturePermissions } from './setFeaturePermissions';

export async function loadPermissions(
  permissionLoader: () => Promise<{
    version: number;
    isPro: boolean;
    plan: PlanType;
  }>
) {
  const { version, isPro, plan } = await permissionLoader();
  const permissions = setFeaturePermissions({ userVersion: version, plan });
  return {
    version,
    isPro,
    plan,
    ...permissions,
  };
}
